import {
  FETCH_USER_ROLES_REQUEST,
  FETCH_USER_ROLES_SUCCESS,
  FETCH_USER_ROLES_FAILURE,
} from "./actionTypes";

export const fetchUserRolesRequest = () => ({
  type: FETCH_USER_ROLES_REQUEST,
});

export const fetchUserRolesSuccess = (data) => ({
  type: FETCH_USER_ROLES_SUCCESS,
  payload: data,
});

export const fetchUserRolesFailure = (error) => ({
  type: FETCH_USER_ROLES_FAILURE,
  payload: error,
});
